import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/cif_logo.jpg'
import _imports_1 from '@/assets/logo.png'
import _imports_2 from '@/assets/appstore.svg'
import _imports_3 from '@/assets/playstore.svg'


const _withScopeId = n => (_pushScopeId("data-v-f10d2ed2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"col\" style=\"padding-bottom:2rem;\" data-v-f10d2ed2><h2 data-v-f10d2ed2>A</h2><a href=\"https://canadaindiafoundation.com/\" target=\"_blank\" data-v-f10d2ed2><img alt=\"Canada India Foundation\" src=\"" + _imports_0 + "\" height=\"100\" data-v-f10d2ed2></a><h2 style=\"padding:1rem;\" data-v-f10d2ed2>Initiative</h2></div><img alt=\"We for Canada India\" src=\"" + _imports_1 + "\" height=\"250\" data-v-f10d2ed2><h1 data-v-f10d2ed2>We For Canada India</h1><h3 data-v-f10d2ed2>Website Coming Soon</h3><h1 data-v-f10d2ed2>Join on our mobile app</h1><div style=\"padding:1rem;\" data-v-f10d2ed2></div>", 6)
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div data-v-f10d2ed2><a href=\"https://apps.apple.com/ca/app/we-for-canada-india/id6480280262\" data-v-f10d2ed2><img alt=\"Download on the App Store\" src=\"" + _imports_2 + "\" height=\"80\" data-v-f10d2ed2></a></div><div style=\"padding:1rem;\" data-v-f10d2ed2></div><div data-v-f10d2ed2><a href=\"https://play.google.com/store/apps/details?id=com.weforcanadaindia.app\" data-v-f10d2ed2><img alt=\"Get it on Google Play\" src=\"" + _imports_3 + "\" height=\"80\" data-v-f10d2ed2></a></div>", 3)
const _hoisted_10 = [
  _hoisted_7
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"padding":"10px"} }, "Questions? Email us at:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:contact@weforcanadaindia.com",
  style: {"color":"blue"}
}, [
  /*#__PURE__*/_createElementVNode("div", null, "contact@weforcanadaindia.com")
], -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: _normalizeClass(!_ctx.isMobile ? 'row' : 'col')
    }, _hoisted_10, 2),
    _createElementVNode("div", {
      style: {"padding-top":"100px"},
      class: _normalizeClass(!_ctx.isMobile ? 'row' : 'col')
    }, _hoisted_13, 2)
  ]))
}